module.exports = __webpack_public_path__ + "img/message1.3ea3efaa.png";